import React, { useEffect } from "react";
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import CaseStudyPage from '../components/CaseStudyPage';
import ProjectModel from '../models/ProjectModel';

function MakerWeek({ dispatch }) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  const model = {
    ...ProjectModel.MakerWeek,
    sections: [
      { type: 'full', ratio: '16 / 9' },
      { type: 'full', cols: 3, ratio: '16 / 9', src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-banner.jpg', caption: 'Physical Banner' },

      { type: 'half', cols: 3, tight: true, images: [
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-slide-1.jpg', ratio: '16 / 9' },
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-slide-2.jpg', ratio: '16 / 9' },
      ]},
      { type: 'half', cols: 3, tight: true, marginTop: '12px', caption: 'Slides', images: [
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-slide-3.jpg', ratio: '16 / 9' },
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-slide-4.jpg', ratio: '16 / 9' },
      ]},

      {
        type: 'motifs-scatter',
      
        items: [
          { label: 'Fig. 1',  src: 'img/project-page/maker-week/MW-1.png',    srcColor: 'img/project-page/maker-week/MW-1-color.png',    left: '0%',  top: '2%',    width: '26%', labelLeft: '0%',  labelTop: '24%' },
          { label: 'Fig. 2',  src: 'img/project-page/maker-week/MW-2.png',    srcColor: 'img/project-page/maker-week/MW-2-color.png',    left: '32%', top: '0%',    width: '17%', labelLeft: '28%', labelTop: '14%' },
          { label: 'Fig. 3',  src: 'img/project-page/maker-week/MW-3.png',    srcColor: 'img/project-page/maker-week/MW-3-color.png',    left: '51%', top: '0%',    width: '26%', labelLeft: '47%', labelTop: '-2%' },
          { label: 'Fig. 4',  src: 'img/project-page/maker-week/MW-4.png',    srcColor: 'img/project-page/maker-week/MW-4-color.png',    left: '78%', top: '3%',    width: '5.8%',  labelLeft: '72%', labelTop: '-2%' },
          { label: 'Fig. 14', src: 'img/project-page/maker-week/MW-14.png',   srcColor: 'img/project-page/maker-week/MW-14-color.png',   left: '86%', top: '0%',    width: '13%', labelLeft: '86.5%', labelTop: '35%' },
          { label: 'Fig. 6',  src: 'img/project-page/maker-week/MW-6.png',    srcColor: 'img/project-page/maker-week/MW-6-color.png',    left: '0%',  top: '35%',   width: '7.5%',  labelLeft: '8%',  labelTop: '38%' },
          { label: 'Fig. 8',  src: 'img/project-page/maker-week/MW-8.png',    srcColor: 'img/project-page/maker-week/MW-8-color.png',    left: '10%', top: '20%',   width: '27.0%', labelLeft: '21%', labelTop: '42.5%' },
          { label: 'Fig. 7',  src: 'img/project-page/maker-week/MW-7.png',    srcColor: 'img/project-page/maker-week/MW-7-color.png',    left: '-2%',  top: '50%', width: '20%', labelLeft: '14%',  labelTop: '79%' },
          { label: 'Fig. 9',  src: 'img/project-page/maker-week/MW-9.png',    srcColor: 'img/project-page/maker-week/MW-9-color.png',    left: '20%', top: '68%',   width: '14%', labelLeft: '28%', labelTop: '67%' },
          { label: 'Fig. 10', src: 'img/project-page/maker-week/MW-10.png',   srcColor: 'img/project-page/maker-week/MW-10-color.png',   left: '38%', top: '33%',   width: '12%', labelLeft: '38%', labelTop: '26%' },
          { label: 'Fig. 10', src: 'img/project-page/maker-week/MW-10-1.png', srcColor: 'img/project-page/maker-week/MW-10-color-1.png', left: '54%', top: '49%', width: '5.5%',  labelLeft: '54%', labelTop: '42.5%' },
          { label: 'Fig. 12', src: 'img/project-page/maker-week/MW-12.png',   srcColor: 'img/project-page/maker-week/MW-12-color.png',   left: '58%', top: '44%', width: '20%', labelLeft: '64.5%', labelTop: '79%' },
          { label: 'Fig. 13', src: 'img/project-page/maker-week/MW-13.png',   srcColor: 'img/project-page/maker-week/MW-13-color.png',   left: '75%', top: '32%',   width: '11%', labelLeft: '76.5%', labelTop: '50.5%' },
          { label: 'Fig. 15', src: 'img/project-page/maker-week/MW-15.png',   srcColor: 'img/project-page/maker-week/MW-15-color.png',   left: '76%', top: '50.0%', width: '25%', labelLeft: '93%', labelTop: '48%' },
        ],
      },
      { type: 'half', cols: 3, tight: true, marginTop: '30px', images: [
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-photo-1.jpg', ratio: '16 / 9' },
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-photo-2.jpg', ratio: '16 / 9' },
      ]},
      { type: 'half', cols: 3, tight: true, marginTop: '12px', caption: 'Photographs of freeing landscapes and clusters of nature', images: [
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-photo-3.jpg', ratio: '16 / 9' },
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-photo-4.jpg', ratio: '16 / 9' },
      ]},

      { type: 'full', cols: 6, centered: true, ratio: '11/14', src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-tshirt.jpg', caption: 'T shirt Design' },

      { type: 'half', cols: 3, tight: true, images: [
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-sketch-1.jpg', ratio: '16 / 9' },
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-sketch-2.jpg', ratio: '16 / 9' },
      ]},
      { type: 'half', cols: 3, tight: true, marginTop: '12px', caption: 'Early sketches of imperfect constructions', images: [
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-sketch-3.jpg', ratio: '16 / 9' },
        { src: 'img/project-page/maker-week/figma-makerweek24-MariaChimishkyan-sketch-4.jpg', ratio: '16 / 9' },
      ]},

      {
        type: 'color-palette',
        perRow: 4,
        colors: [
          { name: 'Butter',  pantone: null,      cmyk: '—',            rgb: '250, 220, 162', hex: '#FADCA2' },
          { name: 'Peach',   pantone: '489 U',   cmyk: '0, 21, 20, 0', rgb: '255, 201, 193', hex: '#FFC9C1' },
          { name: 'Orange',  pantone: '1655 U',  cmyk: '0, 60, 83, 0', rgb: '255, 114, 55',  hex: '#FF7237' },
          { name: 'Blue',    pantone: '306 U',   cmyk: '79, 0, 0, 0',  rgb: '0, 182, 255',   hex: '#00B6FF' },
          { name: 'Coral',   pantone: null,      cmyk: '—',            rgb: '255, 118, 118', hex: '#FF7676' },
          { name: 'Tan',     pantone: null,      cmyk: '—',            rgb: '187, 166, 136', hex: '#BBA688' },
          { name: 'Yellow',  pantone: '3935 U',  cmyk: '4, 0, 55, 0',  rgb: '250, 253, 93',  hex: '#FAFD5D' },
          { name: 'Sage',    pantone: '623 U',   cmyk: '41, 10, 28, 3', rgb: '149, 185, 172', hex: '#95B9AC' },
          { name: 'Cyan',    pantone: null,      cmyk: '—',            rgb: '61, 239, 255',  hex: '#3DEFFF' },
          { name: 'Forest',  pantone: null,      cmyk: '—',            rgb: '34, 47, 40',    hex: '#222F28' },
        ],
      },
    ],
  };

  return <CaseStudyPage projectModel={model} />;
}

export default connect()(MakerWeek);
